import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Table, Typography, notification } from 'antd';
import { useEffect, useState } from 'react';
import apiService from '../../services/api-service';
import { WorkPolicy } from 'src/types/common.types';
type WorkPolicyProps = {
  apiUrl?: string;
  title?: string;
};

const workPolicyUnitOptions = [
  {
    value: 1,
    label: 'Công lắp',
  },
  {
    value: 2,
    label: 'Công bảo hành',
  },
  {
    value: 3,
    label: 'VNĐ',
  },
];
export default function WorkPolicyPage(props: WorkPolicyProps) {
  const apiUrl = '/api/workers/work_policies';
  const [data, setData] = useState<WorkPolicy[]>([]);
  const [currentEditItem, setCurrentEditItem] = useState<WorkPolicy>();
  const [isCreateNewItem, setIsCreateNewItem] = useState(false);
  const [form] = Form.useForm();

  async function getAllData() {
    try {
      const response = await apiService.get<WorkPolicy[]>(apiUrl);
      const sources = response.data;
      if (response.status != 200) {
        throw new Error();
      }
      setData(sources);
    } catch (error: any) {
      notification.error({ message: 'Lỗi tải dữ liệu' });
      console.error(error?.message);
    }
  }
  const onEditItem = (item: WorkPolicy) => {
    setCurrentEditItem(item);
    form.setFieldsValue(item);
  };
  const onPressCreateNewItem = () => {
    setIsCreateNewItem(true);
  };

  const onCreateNewItem = async () => {
    try {
      const submitData = form.getFieldsValue();
      const response = await apiService.post(apiUrl, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Thêm thành công' });
      }
      form.resetFields();
      setIsCreateNewItem(false);
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onUpdateItem = async () => {
    try {
      const submitData: WorkPolicy = form.getFieldsValue();
      submitData.id = currentEditItem!!.id;
      const response = await apiService.put(`${apiUrl}/${currentEditItem!!.id}`, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Cập nhật thành công' });
      }
      onCloseModal();
      getAllData();
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onCloseModal = () => {
    setCurrentEditItem(undefined);
    setIsCreateNewItem(false);
    form.resetFields();
  };
  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div className="p-[24px]">
      <Typography.Title level={4}>{props.title || 'Chính sách công'}</Typography.Title>
      <div className="mb-[16px]">
        <Button size="large" onClick={onPressCreateNewItem} type="primary">
          Tạo mới
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            dataSource={data}
            columns={[
              {
                title: '#ID',
                key: 'id',
                dataIndex: 'id',
              },
              {
                title: 'Mã',
                key: 'code',
                dataIndex: 'code',
              },
              {
                title: 'Name',
                key: 'name',
                dataIndex: 'name',
              },
              {
                title: 'Công lắp',
                key: 'costInstall',
                dataIndex: 'costInstall',
              },
              {
                title: 'Công bảo hành',
                key: 'costWarranty',
                dataIndex: 'costWarranty',
              },
              {
                title: 'Hoạt động',
                key: 'status',
                dataIndex: 'status',
                render: (status: number) => {
                  let text = 'Không';

                  switch (status) {
                    case 1:
                      text = 'Có';
                      break;
                    default:
                      break;
                  }
                  return <>{text}</>;
                },
              },
              {
                title: '',
                render: record => {
                  return <></>;
                },
              },
            ]}
            onRow={(record, rowIndex) => {
              return {
                onClick: e => onEditItem(record),
              };
            }}
          />
        </Col>
      </Row>
      <Modal
        open={!!currentEditItem || isCreateNewItem}
        destroyOnClose={true}
        cancelText="Hủy"
        okText={isCreateNewItem ? 'Lưu' : 'Cập nhật'}
        title={isCreateNewItem ? 'Tạo mới' : 'Cập nhật'}
        onCancel={() => onCloseModal()}
        onOk={isCreateNewItem ? onCreateNewItem : onUpdateItem}
        width={'50vw'}
      >
        <div className="p-2">
          <Form form={form} wrapperCol={{ span: 18 }} labelCol={{ span: 6 }}>
            <Form.Item label="Mã" name="code">
              <Input />
            </Form.Item>
            <Form.Item label="Mô tả" name="name">
              <Input />
            </Form.Item>
            <Form.Item label="Công lắp" name="costInstall">
              <InputNumber min={0} step={5000} className="w-full" />
            </Form.Item>
            <Form.Item label="Công bảo hành" name="costWarranty">
              <InputNumber min={0} step={5000} className="w-full" />
            </Form.Item>
            <Form.Item label="Hoạt động" name="status">
              <Select
                options={[
                  {
                    label: 'Có',
                    value: 1,
                  },
                  {
                    label: 'Không',
                    value: 2,
                  },
                ]}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
